import { normalizeAndMergeState } from './normalize-and-merge-state';
import { ON_FETCH_FAILURE, ON_FULFILLMENT_OFFERINGS_SUCCESS } from '../../action-types';
import { UPDATE_ENTITIES, CLEAR_NORMALIZED_DATA } from './types';

export default function normalizedReducer(state = { result: {} }, action = {}) {
  switch (action.type) {
    case ON_FETCH_FAILURE: {
      const partialError = action.payload?.data;
      // because fetch client will return us normalized error shapes with data we can use that
      // to recover any partial data response using payload.data.<entity>
      return normalizeAndMergeState({ dataToNormalize: partialError?.data || partialError, state });
    }

    case ON_FULFILLMENT_OFFERINGS_SUCCESS:
    case UPDATE_ENTITIES: {
      // NOTE - need to enhance this area or move normalize function call to actions
      // NOTE - flickers are being caused by a blanket merge here.. a deep merge would allow
      // we want these values to be overwritten with each fetch of foffs, do not merge with current state
      const keysToExcludeFromMerge = ['offeringItems', 'locations', 'list'];
      const keysToMergeArrays = ['persistedOfferingItems'];
      return normalizeAndMergeState({
        dataToNormalize: action.payload,
        state,
        keysToExcludeFromMerge,
        keysToMergeArrays,
      });
    }

    case CLEAR_NORMALIZED_DATA:
      return { result: {} };
    default:
      return state;
  }
}
